import makeStyles from '@mui/styles/makeStyles';
import { appPalette } from 'theme/App.palette';
import { theme } from 'theme/App.theme';

const { light_grey_4, acura_red } = appPalette.colors;
export const useStyles = makeStyles({
  root: {
    flexGrow: 1,
    margin: '0 auto',
    padding: '1.25rem',
    [theme.breakpoints.up('viewportMobileMid')]: {
      padding: 0,
      maxWidth: '70%',
      margin: '1.25rem auto',
    },
    [theme.breakpoints.up('viewportMedium')]: {
      maxWidth: 'unset',
      padding: '1.25rem',
      margin: '0',
    },
    [theme.breakpoints.up('viewportLarge')]: {
      width: '95%',
      maxWidth: '78.125rem',
      padding: '2.8125rem 1.25rem',
      margin: '0 auto',
    },
    [theme.breakpoints.up('viewportXLarge')]: {
      width: '90%',
    },
  },
  header: {
    display: 'flex',
    flexDirection: 'column',
    paddingBottom: '3.4375rem',
    '& p': {
      color: light_grey_4,
    },
  },
  dealerContainer: {
    marginBottom: '2.5rem',
    width: '100%',
    [theme.breakpoints.up('viewportMedium')]: {
      marginTop: '2.1875rem',
    },
    [theme.breakpoints.up('viewportLarge')]: {
      marginBottom: '3.75rem',
    },
  },
  errorTag: {
    color: acura_red,
  },
  wrapper: {
    width: '100%',
  },
});
